var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        "enable-background": "new 0 0 20 20",
        version: "1.1",
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 20 20",
        "xml:space": "preserve",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:cc": "http://creativecommons.org/ns#",
        "xmlns:dc": "http://purl.org/dc/elements/1.1/",
        "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
      },
    },
    [
      _c("circle", {
        style: _vm.circleStyle,
        attrs: { cx: "10", cy: "10", r: "10" },
      }),
      _c(
        "text",
        {
          style: _vm.textStyle,
          attrs: {
            x: "50%",
            y: "50%",
            "text-anchor": "middle",
            "font-size": "0.563em",
            dy: ".35em",
          },
        },
        [_vm._v(_vm._s(_vm.text))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }